import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { fundOwnershipUrl } from 'common/config/urls';
import { EmptyTableMessage } from 'components';
import { ValuationsParams } from 'pages/ValuationsAllocation/types';
import GoToFundOwnership from 'pages/Waterfall/components/GoToFundOwnership';
import { NeedsFundOwnershipFirstProps } from './NeedsFundOwnershipFirst.props';

const NeedsFundOwnershipFirst = ({
  measurementDates,
  selectedMeasurementDate,
  title,
  tagline,
}: NeedsFundOwnershipFirstProps) => {
  const { firmSlugParam, companySlugParam } = useParams<ValuationsParams>();

  const fundOwnershipTableTerms = useMemo(
    () => ({
      tableName: 'Fund Ownership',
      tableSlug: 'fund-ownership',
      columnName: 'Ownership',
      pluralColumnName: 'Ownership',
    }),
    []
  );

  const fundOwnershipURL = useMemo(
    () => fundOwnershipUrl(firmSlugParam as string, companySlugParam as string),
    [firmSlugParam, companySlugParam]
  );

  return (
    <EmptyTableMessage
      tableTerms={fundOwnershipTableTerms}
      component={
        <GoToFundOwnership
          fundOwnershipURL={fundOwnershipURL}
          measurementDateSlug={
            (measurementDates || []).find(md => md.id === Number(selectedMeasurementDate?.id))?.slug ?? ''
          }
        />
      }
      title={title}
      tagline={tagline}
    />
  );
};

export default NeedsFundOwnershipFirst;
